module.exports = "https://coursera_assets.s3.amazonaws.com/images/04f290c8baa586175eff911ee952c6a4.png";